import { getExitPages } from '@services/queries'
import { useQuery } from 'react-query'

export function useExitPages(body) {
  const info = useQuery(['exit'], () => getExitPages(body))

  return info
}
